// The store event stream (SSE) — the live plumbing behind Overview and
// Orders. The portal never reasons about event payloads: an event on a
// watched topic means "something changed, reload". The 15-second poll stays
// as the fallback when the stream is down. The bearer rides the query string
// (EventSource cannot set headers); the token is refreshed before connecting.

import { useEffect, useRef } from 'react';
import { freshToken } from './auth';

export function useStoreEvents(base: string, topics: string[], onChange: () => void): void {
  const cb = useRef(onChange);
  cb.current = onChange;
  const key = topics.join(',');
  useEffect(() => {
    let es: EventSource | null = null;
    let stopped = false;
    let timer: ReturnType<typeof setTimeout> | null = null;
    const fire = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => cb.current(), 300);
    };
    void (async () => {
      let token: string;
      try {
        token = await freshToken();
      } catch {
        return;
      }
      if (stopped) return;
      const url = new URL(`/api/v1${base}/events/stream`, window.location.origin);
      url.searchParams.set('token', token);
      url.searchParams.set('topics', key);
      url.searchParams.set('after', String(Math.floor(Date.now() / 1000)));
      es = new EventSource(url);
      es.onmessage = fire;
      es.onerror = () => {
        /* the browser reconnects; the poll covers the gap */
      };
    })();
    return () => {
      stopped = true;
      if (timer) clearTimeout(timer);
      es?.close();
    };
  }, [base, key]);
}
